import { DetailedHTMLProps, FC, SVGProps } from "react";
export const BackIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

<svg className={className} width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.2287 5.99999L6.9427 10.714L6.00003 11.6567L0.814698 6.47132C0.689717 6.3463 0.619507 6.17676 0.619507 5.99999C0.619507 5.82321 0.689717 5.65367 0.814698 5.52866L6.00003 0.343323L6.9427 1.28599L2.2287 5.99999Z" fill="black"/>
</svg>

);
